import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

const GuestDraw = ({ drawData, setShowDrawStatus, closeGuestMask }) => {
    // let guestSayAndImageList = [
    //     { userImage: 'https://d.ifengimg.com/w1125_q90_webp/x0.ifengimg.com/res/2023/060BCEEB34B5EA35A994B0B98311FC2CB9CE969D_size2533_w3778_h2469.jpg' },
    //     { userImage: 'https://d.ifengimg.com/w1125_q90_webp/x0.ifengimg.com/res/2023/C49AA9BCF2E0E197B2F0F66D7760386EF80C0BBA_size1191_w2138_h1603.jpg' },
    //     { userImage: 'https://x0.ifengimg.com/ucms/2022_53/A2B35141B1F9E34B2AA564330A38333DB15EADCD_size35_w680_h449.jpg' },
    //     { userImage: 'https://d.ifengimg.com/w1125_q90_webp/x0.ifengimg.com/res/2023/060BCEEB34B5EA35A994B0B98311FC2CB9CE969D_size2533_w3778_h2469.jpg' },
    //     { userImage: 'https://d.ifengimg.com/w1125_q90_webp/x0.ifengimg.com/res/2023/C49AA9BCF2E0E197B2F0F66D7760386EF80C0BBA_size1191_w2138_h1603.jpg' },
    //     { userImage: 'https://x0.ifengimg.com/ucms/2022_53/A2B35141B1F9E34B2AA564330A38333DB15EADCD_size35_w680_h449.jpg' },
    //     { userImage: 'https://x0.ifengimg.com/ucms/2022_53/A2B35141B1F9E34B2AA564330A38333DB15EADCD_size35_w680_h449.jpg' },
    // ];
    const guestSayAndImageList = drawData.map((item) => item?.userImage || '');
    const [hasDraw, setHasDraw] = useState(true);

    useEffect(() => {
        const swiper = new window.Swiper('.mySwiper', {
            spaceBetween: 0,
            slidesPerView: 6,
            speed: 1500,
            freeMode: true,
            watchSlidesProgress: true,
        });

        new window.Swiper('.mySwiper2', {
            spaceBetween: 0,
            speed: 1500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper,
            },
        });
    }, []);

    return (
        <div className={`${styles.guestDraw} ${hasDraw ? styles.guestOpenDrawAnima : styles.guestCloseDrawAnima}`}>
            <div className={styles.guestDrawBox}>
                <div className={styles.guestDrawTitle}>
                    <img className={styles.guestDrawTitleImg} src="https://x0.ifengimg.com/ucms/2023_49/5296A30A537A622ABB4CD22BD0F7B860105F7498_size9_w186_h50.png" alt="" />
                </div>
                <div className={styles.guestDrawContent}>
                    <div className={styles.bigSwiperBox}>
                        <div className={`swiper mySwiper2 ${styles.bigSwiper}`}>
                            <div className={`swiper-wrapper ${styles.swiperBigWrapper}`}>
                                {guestSayAndImageList.map((item, index) => {
                                    return (
                                        <div key={index} className={`swiper-slide ${styles.swiperBigSlide}`}>
                                            <img src={item} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={`swiper-button-next ${styles.swiperNext}`} />
                    <div className={`swiper-button-prev ${styles.swiperPrev}`} />
                    <div className={styles.smallSwiperBox}>
                        <div className={`swiper mySwiper ${styles.smallSwiper}`}>
                            <div className={`swiper-wrapper ${styles.swiperSmallWrapper}`}>
                                {guestSayAndImageList.map((item, index) => {
                                    return (
                                        <div key={index} className={`swiper-slide ${styles.swiperSmallSlide}`}>
                                            <img src={formatImage(item, 160, 90)} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={styles.guestDrawPrev}
                    onClick={() => {
                        setHasDraw(false);
                        setShowDrawStatus(2);
                        setTimeout(() => {
                            setShowDrawStatus(0);
                        }, 1500);
                    }}
                />
                {/* <div className={styles.guestDrawClose} onClick={closeGuestMask} /> */}
            </div>
        </div>
    );
};

GuestDraw.propTypes = {
    drawData: PropTypes.array,
    setShowDrawStatus: PropTypes.func,
    closeGuestMask: PropTypes.func,
};

export default errorBoundary(GuestDraw);
